/**
 *  추천 상품 페이지 이름
 */
export const RECOMMEND_PRODUCT_PAGE_NAME = {
  RECOMMEND_PRODUCT_LIST: '추천 상품 리스트',
  RECOMMEND_PRODUCT_DETAIL: '추천 상품 상세',
  RECOMMEND_PRODUCT_COPY: '추천 상품 복사',
  RECOMMEND_PRODUCT_CREATE: '추천 상품 등록',
};

/**
 *  추천 상품 타입
 */
export const RECOMMEND_PRODUCT_TYPE = {
  /**
   *  상품 탭 > 트렌드순
   */
  PRODUCT_LIST_RECOMMEND: 0,
  /**
   *  상품 탭 > 인기순
   */
  PRODUCT_LIST_POPULAR: 1,
  /**
   *  상품 상세 하단 추천영역 - 좋아할 만한 상품
   */
  PRODUCT_DETAIL_RECOMMEND_MAY_LIKE: 2,
  /**
   *  검색 화면 - 추천 후기
   */
  SEARCH_RECOMMEND: 3,
};

/**
 *  추천 상품 타입 텍스트
 */
export const RECOMMEND_PRODUCT_TYPE_TEXT = {
  [RECOMMEND_PRODUCT_TYPE.PRODUCT_LIST_RECOMMEND]: '트렌드순',
  [RECOMMEND_PRODUCT_TYPE.PRODUCT_LIST_POPULAR]: '인기순',
  [RECOMMEND_PRODUCT_TYPE.PRODUCT_DETAIL_RECOMMEND_MAY_LIKE]: '좋아할 만한 상품',
  [RECOMMEND_PRODUCT_TYPE.SEARCH_RECOMMEND]: '검색 추천',
};

/**
 *  추천 상품 타입 SELECT 리스트
 */
export const RECOMMEND_PRODUCT_TYPE_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: RECOMMEND_PRODUCT_TYPE.PRODUCT_LIST_RECOMMEND,
    name: RECOMMEND_PRODUCT_TYPE_TEXT[RECOMMEND_PRODUCT_TYPE.PRODUCT_LIST_RECOMMEND],
  },
  {
    id: RECOMMEND_PRODUCT_TYPE.PRODUCT_LIST_POPULAR,
    name: RECOMMEND_PRODUCT_TYPE_TEXT[RECOMMEND_PRODUCT_TYPE.PRODUCT_LIST_POPULAR],
  },
  {
    id: RECOMMEND_PRODUCT_TYPE.PRODUCT_DETAIL_RECOMMEND_MAY_LIKE,
    name: RECOMMEND_PRODUCT_TYPE_TEXT[RECOMMEND_PRODUCT_TYPE.PRODUCT_DETAIL_RECOMMEND_MAY_LIKE],
  },
  {
    id: RECOMMEND_PRODUCT_TYPE.SEARCH_RECOMMEND,
    name: RECOMMEND_PRODUCT_TYPE_TEXT[RECOMMEND_PRODUCT_TYPE.SEARCH_RECOMMEND],
  },
];

/**
 *  추천 상품 메모 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_RECOMMEND_PRODUCT_MEMO = 2000;

/**
 *  추천 상품 아이템 최소 개수
 */
export const MINIMUM_NUMBER_OF_RECOMMEND_PRODUCT_ITEM_COUNT = {
  /**
   *  검색 화면 - 추천 검색어
   */
  [RECOMMEND_PRODUCT_TYPE.SEARCH_RECOMMEND]: 3,
};

/**
 *  추천 상품 아이템 최대 개수
 */
export const MAXIMUM_NUMBER_OF_RECOMMEND_PRODUCT_ITEM_COUNT = {
  /**
   *  검색 화면 - 추천 검색어
   */
  [RECOMMEND_PRODUCT_TYPE.SEARCH_RECOMMEND]: 5,
};
